import { Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormModal } from '../../components/FormModal'

interface IProps {
  isOpen: boolean
  onClose: () => void
  url?: string
  fileName?: string
  fileSize?: number
}

export default function PreviewModal({ isOpen, onClose, url, fileName, fileSize }: IProps) {
  const [isAndroid, setIsAndroid] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor
    setIsAndroid(userAgent.match(/Android/i) ? true : false)
  }, [])

  return url ? (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          {fileName || 'Visualização do arquivo'}{' '}
          {fileSize && (
            <Text variant="caption" as="span">
              ({(fileSize / 1024 / 1024).toFixed(2)} Mb)
            </Text>
          )}
        </>
      }
      size="editor"
    >
      {url.endsWith('.pdf') ? (
        <iframe
          src={isAndroid ? `${process.env.REACT_APP_API_URL}pdf.js/web/viewer.html?file=${url}` : url}
          title={fileName || 'Visualização do arquivo'}
          style={{ width: '100%', height: '75vh' }}
        />
      ) : (
        <img src={url} alt={fileName || 'Visualização do arquivo'} style={{ width: '100%', height: 'auto' }} />
      )}
    </FormModal>
  ) : (
    <></>
  )
}
